/** Release label, independent of wire compatibility. Wire edits MUST bump PROTOCOL_VERSION and its snapshot. */
export const GAME_VERSION = '0.3.17';
